import http from "api/httpClient";

export interface BranchNetwork {
    ou_code: string;
    ou_name: string;
    lat: string | null;
    lon: string | null;
    color?: string;
}

export interface BranchNetworkResponse {
    total: number;
    legend_level: "division" | "zone" | "cluster" | "branch" | string;
    legend: Record<string, string>;
    branches: BranchNetwork[];
}

export interface BranchNetworkRequest extends Record<string, unknown> {
    filters: Record<string, string[]>;
    search?: string;
}


export interface EmployeeInfo {
  first_name: string | null;
  last_name: string | null;
  employee_photo_url: string | null;
  work_email: string | null;
  designation: string | null;
  department: string | null;
  date_of_joining: string | null;
  mobile_number: string | null;
}

export interface BranchInfo {
  ou_code: string | null;
  ou_name: string | null;
  address: string | null;
}

export interface BranchDetails {
  branch: BranchInfo;
  employees: EmployeeInfo[];
}


export async function fetchBranchNetworkData(params: BranchNetworkRequest): Promise<BranchNetworkResponse> {
    return http.post("/api/v1/branch-network/fetch-data", params);
}

export async function fetchBranchDetails(ouCode: string): Promise<BranchDetails> {
  return http.get(`/api/v1/branch-network/branch-details/${ouCode}`)}
